import { z } from 'zod';
import { ERROR_CODES } from '../constants/error-codes.js';
import { documentTypeSchema, documentStatusSchema } from './enums.js';
export const documentLockIssueKindSchema = z.enum([
    'permission',
    'version',
    'locked',
    'status',
    'required',
    'modeMissing',
    'modeCleanup',
    'modeRecord',
    'vatUnavailable',
    'vatRequired',
    'modeVat',
    'taxPrerequisites',
    'transport',
    'overridePermission',
    'overrideReason',
    'technical',
]);
export const documentLockIssueSchema = z.object({
    kind: documentLockIssueKindSchema,
    code: z.nativeEnum(ERROR_CODES),
    field: z.string(),
    severity: z.enum(['BLOCKER', 'WARNING']),
});
export const documentLockContextSchema = z.object({
    documentId: z.string(),
    customerId: z.string(),
    documentType: documentTypeSchema,
    documentStatus: documentStatusSchema,
    version: z.number().int(),
    requestedVersion: z.number().int().nullable(),
    environment: z.enum(['development', 'test', 'staging', 'production']),
    mode: z.enum(['UNCLASSIFIED', 'INTRODUCTION', 'CLEANING', 'CLEANUP_FAILED', 'LIVE', 'MISSING']),
    modeVersion: z.number().int().nullable(),
    phaseId: z.string().nullable(),
    recordOrigin: z.enum(['TEST', 'UNMARKED']),
    recordPhaseId: z.string().nullable(),
});
export const documentLockAssessmentSchema = documentLockContextSchema.extend({
    checkedAt: z.string().datetime(),
    canLock: z.boolean(),
    issues: z.array(documentLockIssueSchema),
});
export const documentLockAttemptSchema = documentLockContextSchema.extend({
    attemptId: z.string().uuid(),
    attemptedAt: z.string().datetime(),
    outcome: z.enum(['FAILED', 'SUCCEEDED']),
    code: z.string(),
    reason: z.string(),
    reference: z.string().nullable(),
    issues: z.array(documentLockIssueSchema),
});
export const documentLockHistorySchema = z.object({
    data: z.array(z.object({
        id: z.string(),
        actorName: z.string().nullable(),
        attempt: documentLockAttemptSchema,
    })),
});
//# sourceMappingURL=document-lock.js.map